class VariantPicker extends HTMLElement {
  connectedCallback() {
    this.select = this.querySelector('select[name="id"]');
    this.radios = this.querySelectorAll('input[type="radio"]');
    this.radios.forEach(r => r.addEventListener('change', () => this.onChange()));
  }
  onChange() {
    const values = [...this.querySelectorAll('fieldset')].map(f => f.querySelector('input:checked')?.value);
    const option = [...this.select.options].find(o => values.every(v => o.text.includes(v)));
    if (option) {
      this.select.value = option.value;
      this.dispatchEvent(new CustomEvent('variant:changed', { bubbles: true, detail: { variantId: option.value } }));
      const url = new URL(window.location);
      url.searchParams.set('variant', option.value);
      history.replaceState({}, '', url);
    }
  }
}
customElements.define('variant-picker', VariantPicker);
